
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { yellow, highlight } from '@mdx-deck/themes'
import Link from './components/Link.jsx'
import VirtualDOMNode from './images/virtualDOMNode.jpg'
import LifecycleMethods from './components/LifecyleMethods.jsx'
import { Head } from 'mdx-deck'
import ControlledInput from './components/ControlledInput.jsx'
import NameInput from './components/UserReducerComponent.jsx'
import CounterComponent from './components/CounterReducerComponent.jsx'
import ConventionalCounter from './components/CoventionalReducerComponent.jsx'
export const theme = { ...yellow,
  ...highlight
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Footer = makeShortcode("Footer");
const Steps = makeShortcode("Steps");
const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Head mdxType="Head">
    <title>React workshop</title>
    <meta name="og:image" content="data:image/png;base64,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" />
    </Head>
    <Footer mdxType="Footer">
    <p style={{
        textAlign: 'center'
      }}>created with &lt;/&gt; by Apurv Khare</p>
    </Footer>
    <h3>{`I created this slides as part of my react workshop`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`In these slides(70+), I share all the knowledge required to learn`}<br parentName="p"></br>{`
`}{`and understand React`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`These slides can also be used to revise React concepts before an interview`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use right/down arrow key to move forward and left/up arrow to move backwards`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`press alt+o to navigate to different slides`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If you find this helpful or want to share feedback, reach out to`}<br parentName="p"></br>{`
`}{`me on `}<Link url="https://www.linkedin.com/in/apurvkhare/" mdxType="Link">{`linkedin`}</Link></p>
      </li>
    </ul>
    <hr></hr>
    <h1>{`What is `}<Link url="https://reactjs.org/" mdxType="Link">{`React`}</Link>{`?`}</h1>
    <ul>
    <Steps mdxType="Steps">
        <li>React is a</li> 
        <li>declarative</li>
        <li>component-based</li>
        <li>JavaScript library for building user interfaces</li>
        <li>which can be learned once and written anywhere</li>
    </Steps>
    </ul>
    <hr></hr>
    <h2>{`Building UI with plain JavaScript`}</h2>
    <p>{`Refer to code `}<Link url="https://github.com/apurvkhare/react-in-depth/blob/main/chapter-1/index.html" mdxType="Link">{`here`}</Link></p>
    <hr></hr>
    <h2>{`Building UI with React`}</h2>
    <p>{`So what do we need to develop UI with React?`}</p>
    <ul>
      <Steps mdxType="Steps">
    <li>using CRA(create-react-app) template?</li>
    <li>configuring a custom webpack React app?</li>
    <li>is there a simpler way?</li>
    <li>Yes, using the <Link url="https://reactjs.org/docs/cdn-links.html#gatsby-focus-wrapper" mdxType="Link">CDN links</Link> to React and ReactDOM APIs</li>
    <li>Refer to code <Link url="https://github.com/apurvkhare/react-in-depth/blob/main/chapter-1/index.html" mdxType="Link">here</Link></li>
      </Steps>
    </ul>
    <hr></hr>
    <h3>{`Is there a better alternative way to create React elements?`}</h3>
    <ul>
      <li parentName="ul">{`Yes, using JSX(JavaScript XML).`}</li>
      <li parentName="ul">{`It is simply a syntax extension of JavaScript.`}<br parentName="li"></br>
        {`It allows us to directly write HTML in React (within JavaScript code)`}</li>
      <li parentName="ul">{`We require a transpiler which would convert the JSX into React.createElement()`}</li>
      <li parentName="ul">{`Hence we make use of Babel.`}</li>
      <li parentName="ul">{`Just like React and ReactDOM, we can get the `}<Link url="https://unpkg.com/@babel/standalone@7.14.6/babel.min.js" mdxType="Link">{`CDN link`}</Link>{` for Babel.`}</li>
    </ul>
    <p>{`Refer to code `}<Link url="https://github.com/apurvkhare/react-in-depth/blob/main/chapter-1/index.html" mdxType="Link">{`here`}</Link></p>
    <hr></hr>
    <h2>{`Now we understand how CRA works`}</h2>
    <ul>
      <li parentName="ul">{`Create a React app using CRA template`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`npx create-react-app my-app
or
yarn create react-app my-app
`}</code></pre>
    <hr></hr>
    <h2>{`How does React update UI? Virtual DOM`}</h2>
    <ul>
      <li parentName="ul">{`Virtual DOM is the tree of objects created by React.createElement() API`}</li>
      <li parentName="ul">{`When a React component mounts, a Virtual DOM of current UI is created`}</li>
      <li parentName="ul">{`When a state or prop update occurs another virtual DOM is created`}</li>
      <li parentName="ul">{`The 2 Virtual DOM are compared and whatever changes are detected,`}<br parentName="li"></br>
        {`are batched and the Real DOM is updated`}</li>
      <li parentName="ul">{`Creating virtual DOM is extremmely fast as each nodes are just plain objects`}</li>
    </ul>
    <hr></hr>
    <h2>{`A virtual DOM Node`}</h2>
    <img src={VirtualDOMNode} style={{
      width: 1200,
      objectFit: "contain"
    }} />
    <hr></hr>
    <h2>{`UNderstanding how to write JSX`}</h2>
    <ul>
      <li parentName="ul">{`JSX elements can be considered as a HTML Element,`}<br parentName="li"></br>
        {`except that they are more powerful.`}</li>
      <li parentName="ul">{`JSX attributes unlike HTML are written in camelcase,`}<br parentName="li"></br>
        {`to add a class you need to add "className" attribute`}</li>
      <li parentName="ul">{`JSX accepts dynamic values through "{}"`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    const displayText = "I can do this all day"

    <div className="container">
        <h3>{displayText}</h3>
        <button onClick={() => console.log("Button clicked")}>Click Me</button>
    </div>
`}</code></pre>
    <hr></hr>
    <h2>{`styling a JSX element`}</h2>
    <ul>
      <li parentName="ul">{`In React there are multiple ways to style a component.`}</li>
      <li parentName="ul">{`an external ".css" file that can be imported and`}<br parentName="li"></br>
        {`accordingly classnames can be added to JSX elements`}</li>
      <li parentName="ul">{`Other ways are    `}
        <ul parentName="li">
          <li parentName="ul">{`Module CSS `}</li>
          <li parentName="ul">{`Styled component`}</li>
          <li parentName="ul">{`external libraries like matrial-ui, ant design, emotion, etc`}</li>
        </ul>
      </li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul">{`To give inline style you can assign a style object to the`}<br parentName="li"></br>
        {`style attribute of the JSX element`}</li>
      <li parentName="ul">{`The style object will contain the css propeties as key-value pairs,`}<br parentName="li"></br>
        {`and incase of multi word css keys they will be camel-cased`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const styleObj = {
    color: "white",
    backgroundColor: "black"
}

<div style={styleObj}>
    <h3>I am inevitable</h3>
</div>
`}</code></pre>
    <hr></hr>
    <h2>{`What is a state?`}</h2>
    <p>{`In most simple words, anything in your UI which changes is a state.`}<br parentName="p"></br>{`
`}{`Lets, take an example of `}<Link url="https://www.amazon.in" mdxType="Link">{`Amazon`}</Link></p>
    <h2>{`How do we handle state in React?`}</h2>
    <p>{`Handling state depends on the type of component.`}<br parentName="p"></br>{`
`}{`State is handled differently in class components and functional components.`}<br parentName="p"></br>{`
`}{`Prior to React version 16.8 only class components could contain state,`}<br parentName="p"></br>{`
`}{`but after that with the introduction of hooks even functional components can contain state.`}</p>
    <hr></hr>
    <h2>{`Managing state in class components`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react'

class UserComponent extends React.Component {
    constructor(){
        super()
        this.state={
            name: 'Guest',
            age: 20
        }
    }

    render(){
        return <div>
            <h1> I am a class component </h1>
            <h3> User Name : {this.state.name} </h3>
            <h3> User Age : {this.state.age} </h3>
            <button 
            onClick={() => this.setState({...this.state, name: 'Apurv', age: 25})}
            >
            update user
            </button>
        </div>
    }
}
`}</code></pre>
    <hr></hr>
    <h2>{`Managing state in Functional components`}</h2>
    <ul>
      <li parentName="ul">{`React provides a hook called useState to manage state in functional components`}</li>
      <li parentName="ul">{`So what is a hook?`}
        <ul parentName="li">
          <li parentName="ul">{`Hooks are nothing but functions that let you use state and`}<br parentName="li"></br>
            {`other React features without writing a class.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`useState is a function that takes initial value of the state`}<br parentName="li"></br>
        {`as an argument and returns an array`}<br parentName="li"></br>
        {`which contains the state and setter function for the state.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const [name, setName] = React.useState('Guest')
`}</code></pre>
    <hr></hr>
    <h2>{`Now lets understand different`}</h2>
    <h2><Link url="https://projects.wojtekmaj.pl/react-lifecycle-methods-diagram/" mdxType="Link">{`phases`}</Link>{` of a React component`}</h2>
    <ol>
      <li parentName="ol">{`Mounting - When the component is rendered for the first time.`}</li>
      <li parentName="ol">{`Updating - When the component renders due to a state or prop change.`}<br parentName="li"></br>
        {`(there are a few other scenarios for re-rendering)`}</li>
      <li parentName="ol">{`Unmounting - When the component is about to be removed from the DOM.`}</li>
    </ol>
    <hr></hr>
    <h2>{`Component Lifecycle methods`}</h2>
    <ul>
      <li parentName="ul">{`Each component has several “lifecycle methods” that you can override`}<br parentName="li"></br>
        {`to run code at particular time in the process.`}</li>
      <li parentName="ul">{`We will talk about 3 main lifecycle methods for now.`}
        <ul parentName="li">
          <li parentName="ul">{`componentDidMount() - runs after the component has rendered for the first time`}</li>
          <li parentName="ul">{`componentDidUpdate() - runs after the component has re-rendered`}</li>
          <li parentName="ul">{`componentWillUnmount() - runs just before a component is to be removed from DOM`}</li>
        </ul>
      </li>
      <li parentName="ul">{`As the name suggest these are "methods" and not functions hence`}<br parentName="li"></br>
        {`they can be overridden only in class components.`}</li>
    </ul>
    <hr></hr>
    <h2>{`useEffect hook`}</h2>
    <ul>
      <li parentName="ul">{`What if you wanted to enact the lifecycle methods in functional components?`}</li>
      <li parentName="ul">{`Remeber the hooks definition,... yes you have a hook for that - useEffect`}</li>
      <li parentName="ul">{`Lets see how we can use the useEffect hook to enact the three main lifecycle methods`}</li>
      <li parentName="ul">{`useEffect takes two arguments`}
        <ol parentName="li">
          <li parentName="ol">{`a callback function to be executed`}</li>
          <li parentName="ol">{`a depedency array which decides when the callback is executed`}</li>
        </ol>
      </li>
      <li parentName="ul">{`useEffect optionally returns a callback function`}<br parentName="li"></br>
        {`which will be executed just before the component is unmounting`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// componentDidMount
React.useEffect(() => {
    console.log("I am called only when the component is mounted")
}, [])

// componentDidUpdate
const [name, setName] = React.useState('Guest')
React.useEffect(() => {
    console.log("I am called when the component has 
    mounted and whenever the name state is updated")
}, [name])

//componentWillUnmount
React.useEffect(() => {
    return () => {
        console.log("I am called just before the component is unmounting  
        and when the component is re-rendered")
    }
}, [])
`}</code></pre>
    <hr></hr>
    <LifecycleMethods mdxType="LifecycleMethods" />
    <hr></hr>
    <h2>{`creating a custom React app`}</h2>
    <ul>
      <li parentName="ul">{`For developing a React Project we can make use of CRA(create-react-app) template`}</li>
      <li parentName="ul">{`But in most enterprise web applications, the React app is custom configured`}</li>
      <li parentName="ul">
        <Link url="https://webpack.js.org/" mdxType="Link">Webpack</Link> is a bundler which can be used to configure a React app
      </li>
      <li parentName="ul">{`Other options are `}
        <ul parentName="li">
          <li parentName="ul">{`esbuild`}</li>
          <li parentName="ul">{`parcel`}</li>
          <li parentName="ul">{`rollup`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Check `}<Link url="https://github.com/apurvkhare/react-app-biolerplate" mdxType="Link">{`here`}</Link>{` for a custom react app with webpack`}</li>
    </ul>
    <hr></hr>
    <h2>{`what are props?`}</h2>
    <ul>
      <li parentName="ul">{`props are custom attributes of JSX elements and components which can be used`}<br parentName="li"></br>
        {`to pass state information from a Parent component to child component`}</li>
      <li parentName="ul">{`props are read-only and should not be changed by the component that is using it`}</li>
      <li parentName="ul">{`we can pass state only down the tree using props,`}<br parentName="li"></br>
        {`we cannot pass state value from child component to parent component.`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Home = () => {
    const [userName, setUserName] = React.useState('Guest')

    return <div>
        <h1>Home Page</h1>
        <User userName={userName}/>
    </div>
}

const User = ({userName}) => {
    return <div>
        <h3>Welcome, {userName}</h3>
    </div>
}
`}</code></pre>
    <hr></hr>
    <h2>{`How can we validate props?`}</h2>
    <ul>
      <li parentName="ul">{`We can validate the props by using the 'prop-types' node module.`}</li>
      <li parentName="ul">{`We can specify the type of each prop and also whether a prop`}<br parentName="li"></br>
        {`has to be passed manditorily`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import PropTypes from 'prop-types'

const User = ({userName, age, updateProfile}) => {
    return <div>
        <h3>Welcome, {userName}</h3>
        <p>update age</p>
        <input type="number" value={age}/>
        <button onClick={updateProfile}>update</button>
    </div>
}

User.propTypes = {
    userName: PropTypes.string.isRequired,
    age: PropTypes.number.isRequired,
    updateProfile: PropTypes.func.isRequired
}
`}</code></pre>
    <hr></hr>
    <h2>{`Conditional rendering`}</h2>
    <ul>
      <li parentName="ul">{`Sometimes we want to show separate UI based on certain state or conditon.`}</li>
      <li parentName="ul">{`There are multiple ways to achieve it`}
        <ul parentName="li">
          <li parentName="ul">{`Logical AND (&&) operator`}</li>
          <li parentName="ul">{`Conditional operator (?:)`}</li>
          <li parentName="ul">{`if conditons, return different UI for different conditons`}</li>
        </ul>
      </li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const [data, setData] = React.useState([])

return <div>
    {data && data.length !== 0 ? 
    <h3>Data is present</h3> :
    <h3>No data to show</h3>}
</div>
`}</code></pre>
    <hr></hr>
    <h2>{`Displaying list of data`}</h2>
    <ul>
      <li parentName="ul">{`To display a list of data, mostly from an array, we make use of`}<br parentName="li"></br>
        {`the map higher order function of array`}</li>
      <li parentName="ul">{`One important thing to make note of is to pass a unique id`}<br parentName="li"></br>
        {`to the key prop of each component.`}</li>
      <li parentName="ul">{`unique keys help React know which items have changed, are`}<br parentName="li"></br>
        {`added, or are removed. Helping the diffing algorithm identify changes`}<br parentName="li"></br>
        {`in virtual DOM nodes.`}</li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul">{`Do not use array index as key, because if an element is removed`}<br parentName="li"></br>
        {`from middle of an array, the rest of the indices after that element`}<br parentName="li"></br>
        {`will get updated but the actual data of the component hasn't changed.`}<br parentName="li"></br>
        {`Causing unnecessary re-render.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// redering data from an array 
const [data, setData] = React.useState([])

return <div>
    {data && data.length !== 0 ? 
    data.map(dataItem => <p key={dataItem.id}>{dataItem.name}</p>) :
    <h3>No data to show</h3>}
</div>
`}</code></pre>
    <hr></hr>
    <h2>{`controlled inputs`}</h2>
    <ul>
      <li parentName="ul">{`React allows us to programmatically set the value prop on the input`}</li>
      <li parentName="ul">{`we can assign a state value to the value prop and handle the change`}<br parentName="li"></br>
        {`of value by letting onChangeHandler set the state value.`}</li>
      <li parentName="ul">{`Using controlled input we can mange the input values better as`}<br parentName="li"></br>
        {`they would just be the state values.`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// here we are controlling the input to be only uppercase
const User = () => {
    const [name, setName] = React.useState('')

    const handleChange = (e) => setName(e.target.value.toString().toUpperCase())

    return <div>
        <h3>Enter your name</h3>
        <input type="text" value={name} onChange={handleChange} />
    </div>
}
`}</code></pre>
    <hr></hr>
    <ControlledInput mdxType="ControlledInput" />
    <hr></hr>
    <h2>{`Lifting the state up`}</h2>
    <ul>
      <li parentName="ul">{`Keeping the state as close to the component makes the component render fast.`}<br parentName="li"></br>
        {`But sometimes we need to share the same state among different components.`}<br parentName="li"></br>
        {`And if those components are sibling components then simply`}<br parentName="li"></br>
        {`lifting the state up the tree will solve the problem.`}</li>
      <li parentName="ul">{`Let's understand this by example.  `}
        <ul parentName="li">
          <li parentName="ul">{`We have a component Home`}</li>
          <li parentName="ul">{`We need to develop a component Profile`}<br parentName="li"></br>
            {`which will display the user's name.`}</li>
        </ul>
      </li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Home = () => {
    return <div>
        <Profile />
    </div>
}

const Profile = () => {
    const [name, setName] = React.useState('Guest')

    return<div>
        <h3>Your User Name: {name}</h3>
    </div>
}
`}</code></pre>
    <hr></hr>
    <ul>
      <li parentName="ul">{`Now we get a reqiurement to make another component Greeting.`}</li>
      <li parentName="ul">{`This component also requires the user's name to display.`}</li>
      <li parentName="ul">{`This component will be placed in the Home component and will`}<br parentName="li"></br>
        {`be a sibling to Profile component.`}</li>
      <li parentName="ul">{`Now since both these component require access to the same state`}<br parentName="li"></br>
        {`which is currently present in Profile, we can lift the state up to`}<br parentName="li"></br>
        {`Home component and then pass the state as a prop to both the component.`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Home = () => {
    const [name, setName] = React.useState('Guest')

    return <div>
        <Profile name={name}/>
        <Greeting name={name}/>
    </div>
}

const Profile = ({name}) => {
    return<div>
        <h3>Your User Name: {name}</h3>
    </div>
}

const Greeting = ({name}) => {
    return<div>
        <h3>Welcome {name}, Good morning</h3>
    </div>
}
`}</code></pre>
    <hr></hr>
    <ul>
      <li parentName="ul">{`Let's continue with our previous example, it so happened that the Greeting`}<br parentName="li"></br>
        {`component is now part of Welcome component. And so now Welcome and Profile are`}<br parentName="li"></br>
        {`sibling components.`}</li>
      <li parentName="ul">{`So now the name state is first passed to Welcome and then Welcome passes it`}<br parentName="li"></br>
        {`on to the Greeting component`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Home = () => {
    const [name, setName] = React.useState('Guest')

    return <div>
        <Profile name={name}/>
        <Welcome name={name}/>
    </div>
}

const Welcome = ({name}) => {
    return<div>
        ...
        ...
        <Greeting name={name} />
    </div>
}
`}</code></pre>
    <hr></hr>
    <ul>
      <li parentName="ul">{`Now the Greeting component had to be divided into some components.`}<br parentName="li"></br>
        {`And our welcome message became the part of GreetingMsg component.`}</li>
      <li parentName="ul">{`So now we would need to pass down the name prop one more level`}<br parentName="li"></br>
        {`down the tree to GreetingMsg component`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Greeting = ({name}) => {
    return<div>
        ...
        ...
        <GreetingMsg name={name} />
    </div>
}

const GreetingMsg = ({name}) => {  
    return <h3>Welcome {name}, Good morning</h3>
}
`}</code></pre>
    <hr></hr>
    <h2>{`prop drilling`}</h2>
    <ul>
      <li parentName="ul">{`If you notice there are two components, namely Welcome and Greeting`}<br parentName="li"></br>
        {`which actually do not consume the name prop but are just passing it`}<br parentName="li"></br>
        {`down further to the next component.`}</li>
      <li parentName="ul">{`So we see that the state name is passed down 3 level down via props.`}</li>
      <li parentName="ul">{`This is known as prop drilling.`}</li>
      <li parentName="ul">{`There are two ways to solve prop drilling`}
        <ul parentName="li">
          <li parentName="ul">{`composition `}</li>
          <li parentName="ul">{`context API`}</li>
        </ul>
      </li>
    </ul>
    <hr></hr>
    <h2>{`children prop`}</h2>
    <ul>
      <li parentName="ul">{`composition uses the special "children" prop to solve the prop drilling issue`}</li>
      <li parentName="ul">{`children contains everything that is wrapped between a component.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<User>
    <h1>This is a user component</h1>
    <Profile/>
    <Wishlist />
</User>
// Here the h1, Profile, Wishlist all are children of User
// and can be accessed in User component via children prop
`}</code></pre>
    <hr></hr>
    <h2><Link url="https://reactjs.org/docs/context.html#before-you-use-context" mdxType="Link">{`composition`}</Link></h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Welcome = ({name, children}) => {
    return<div>
        ...
        ...
        {children}
    </div>
}

const Greeting = ({name, children}) => {
    return<div>
        ...
        ...
        {children}
    </div>
}

const Home = () => {
    const [name, setName] = React.useState('Guest')

    return <div>
        <Profile name={name}/>
        <Welcome>
            <Greeting>
                <GreetingMsg name={name}/>
            </Greeting>
        </Welcome>
    </div>
}
`}</code></pre>
    <hr></hr>
    <h2>{`Context API`}</h2>
    <ul>
      <li parentName="ul">{`In order to share state through Context API we need to`}
        <ul parentName="li">
          <li parentName="ul">{`create a context`}</li>
          <li parentName="ul">{`create a context provider component`}</li>
          <li parentName="ul">{`use the context`}</li>
        </ul>
      </li>
      <li parentName="ul">{`a context can be created as follows`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    const UserContext = React.createContext()
    // we can pass initial state value as a argument to createContext
`}</code></pre>
    <hr></hr>
    <h2>{`Context Provider Component`}</h2>
    <ul>
      <li parentName="ul">{`A Context Provider is a component which conatins the state and`}<br parentName="li"></br>
        {`will wrap all the components that need to access the state`}<br parentName="li"></br>
        {`present in the context.`}</li>
      <li parentName="ul">{`Just like composition it also makes use of children prop`}</li>
      <li parentName="ul">{`The state and functions required to manipulate the state are`}<br parentName="li"></br>
        {`passed as an object to the value prop of the Provider.`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const UserProvider = ({children}) => {
    const [name, setName] = React.useState('Guest')

    const value = {
        name,
        setName
    }

    return<UserContext.Provider value={value}>
        {children}
    </UserContext.Provider>
}  
`}</code></pre>
    <hr></hr>
    <ul>
      <li parentName="ul">{`The last part is to create a custom hook to use the context.`}</li>
      <li parentName="ul">{`creating a custom hook is not compulsory,`}<br parentName="li"></br>
        {`we can directly make use of useContext hook in the`}<br parentName="li"></br>
        {`components that need to access state from the context.`}</li>
      <li parentName="ul">{`But the following custom hook takes care of an error`}<br parentName="li"></br>
        {`case when someone tries to access the context in a component`}<br parentName="li"></br>
        {`which was not wrapped with the ContextProvider`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const useUser = () => {
    const context = React.useContext(UserContext)
    if(!context)
        throw new Error('useUser context can only  
        be used in a component wrapped with UserProvider')
    return context
}
`}</code></pre>
    <hr></hr>
    <ul>
      <li parentName="ul">{`Now our Profile and Welcome will be wrapped with`}<br parentName="li"></br>
        {`UserProvider in the Home component`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Home = () => {
    return <div>
        <UserProvider>
            <Profile />
            <Welcome />
        </UserProvider>
    </div>
}
`}</code></pre>
    <hr></hr>
    <ul>
      <li parentName="ul">{`Welcome and Greeting component will now not be passing down the props`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Welcome = () => {
    return<div>
        ...
        ...
        <Greeting />
    </div>
}

const Greeting = () => {
    return<div>
        ...
        ...
        <GreetingMsg />
    </div>
}

`}</code></pre>
    <hr></hr>
    <ul>
      <li parentName="ul">{`Profile and GreetingMsg component which need to access`}<br parentName="li"></br>
        {`the state from context will access it with useUser`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const GreetingMsg = () => {
    const { name } = useUser()

    return <h3>Welcome {name}, Good morning</h3>
}

// Similary Profile component will also access the state
`}</code></pre>
    <hr></hr>
    <h2>{`useReducer Hook`}</h2>
    <ul>
      <li parentName="ul">{`useReducer is usually preferable to useState when you have complex state logic`}<br parentName="li"></br>
        {`that involves multiple sub-values or when the next state depends on the previous one.`}</li>
      <li parentName="ul">{`useReducer takes two arguments`}
        <ul parentName="li">
          <li parentName="ul">{`a reducer function of type (state, action) => newState`}</li>
          <li parentName="ul">{`the initial state`}</li>
        </ul>
      </li>
      <li parentName="ul">{`useReducer returns an array containing the current state paired with a`}<br parentName="li"></br>
        {`dispatch(state updater) method`}</li>
      <li parentName="ul">{`Now we'll see how we can make use of useReducer to manage state,`}<br parentName="li"></br>
        {`if you are already familiar with Redux then prepare to be mind-blown.`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`function userNameReducer(currUser, newUser) {
  return newUser
}

const defaultUser = 'Tony'

function NameInput() {
  const [user, setUser] = React.useReducer(userNameReducer, defaultUser)
  const handleChange = e => setUser(e.target.value)
  return (
    <div>
      <label>
        User Name: <input value={user} onChange={handleChange} />
      </label>
      <h3>You typed: {user}</h3>
    </div>
  )
}

`}</code></pre>
    <hr></hr>
    <NameInput mdxType="NameInput" />
    <hr></hr>
    <ul>
      <li parentName="ul">{`Let's understand "userNameReducer"`}</li>
      <li parentName="ul">{`The reducer function takes 2 arguments`}
        <ul parentName="li">
          <li parentName="ul">{`initail state / current state`}</li>
          <li parentName="ul">{`new state information (commonly known as action object)`}</li>
        </ul>
      </li>
      <li parentName="ul">{`The usual convention according to Redux is to have an action`}<br parentName="li"></br>
        {`object with "type" key which states how the state is to be`}<br parentName="li"></br>
        {`updated and optional "payload" key which has the new state information`}</li>
      <li parentName="ul">{`But that's just the convention of Redux, the reducer passed to`}<br parentName="li"></br>
        {`useReducer does not require to follow the same convention.`}</li>
      <li parentName="ul">{`Hence in the second argument of the userNameReducer is`}<br parentName="li"></br>
        {`directly the new state value.`}</li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul">{`Let's understand "useReducer"`}</li>
      <li parentName="ul">{`As expected it takes a reducer function - "userNameReducer"`}<br parentName="li"></br>
        {`and the initial state - "defaultUser" as arguments.`}</li>
      <li parentName="ul">{`it returned the current state, stored in - "user"`}<br parentName="li"></br>
        {`and a state updater - "setUser"`}</li>
      <li parentName="ul">{`IMPORTANT - whatever we pass to the state updater function`}<br parentName="li"></br>
        {`as an argument, that becomes the second argument to the reducer`}<br parentName="li"></br>
        {`function.`}</li>
      <li parentName="ul">{`Here, we passed "e.target.value" (input value) to setUser`}<br parentName="li"></br>
        {`Hence the newState param of reducer will have the same value.`}</li>
      <li parentName="ul">{`Let's see another non-convetional example of useReducer`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const countReducer = (currCount, step) => {
    return currCount + step
}

const initialCount = 0
const step = 3

const CounterComponent = () => {
    const [count, changeCount] = React.useReducer(countReducer, initialCount)
    const increment = () => changeCount(step)

    return (
    <div>
      <h3>Counter value: {count}</h3>
      <button onClick={increment}>increment</button>
    </div>
  )
}
`}</code></pre>
    <hr></hr>
    <CounterComponent mdxType="CounterComponent" />
    <ul>
      <li parentName="ul">{`Here we passed the step value to the state updater - "changeCount"`}<br parentName="li"></br>
        {`which becomes the value of step param in countReducer and now we`}<br parentName="li"></br>
        {`use the step value to increment the current count value.`}</li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul">{`Now lets see the code for conventional reducer function`}</li>
      <li parentName="ul">{`The second argument to the reducer will be an action object`}</li>
      <li parentName="ul">{`The action object contains type and payload(optional)`}</li>
      <li parentName="ul">{`We update the state based on the action type we recieve`}</li>
      <li parentName="ul">{`For comparing type we can either use if else or switch case`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const initialState = {
    count: 0
    // lot other state values
}

const countReducer = (state = initialState, action) => {
    switch (action.type) {
        case "increment":
            return {
                ...state,
                count: state.count + action.payload.step,
            }
        
        case "decrement":
            return {
                ...state,
                count: state.count - action.payload.step,
            }
        
        case "clear":
            return {
                ...state,
                count: 0,
            }
    
        default:
            return state
    }
}


const step = 3

const CounterComponent = () => {
    const [state, dispatch] = React.useReducer(countReducer, initialState)
    const increment = () => dispatch({
        type: 'increment',
        payload: {
            step
        } 
    })

    const decrement = () => dispatch({
        type: 'decrement',
        payload: {
            step
        } 
    })

    const clear = () => dispatch({
        type: 'clear' 
    })

    return (
    <div>
      <h3>Counter value: {count}</h3>
      <button onClick={increment}>increment</button>
      <button onClick={decrement}>decrement</button>
      <button onClick={clear}>reset</button>
    </div>
  )
}
`}</code></pre>
    <hr></hr>
    <ConventionalCounter mdxType="ConventionalCounter" />
    <hr></hr>
    <h2>{`useRef`}</h2>
    <ul>
      <li parentName="ul">{`useRef hook is used for 2 purpose`}
        <ul parentName="li">
          <li parentName="ul">{`to access the DOM element via ref prop`}</li>
          <li parentName="ul">{`to store a value that is persistent among renders`}</li>
        </ul>
      </li>
      <li parentName="ul">{`useRef takes only one argument which initializes the ".current"
property of ref object`}</li>
      <li parentName="ul">{`useRef returns a mutable object which conatins a current property`}</li>
    </ul>
    <hr></hr>
    <h2>{`Accessing the DOM elements`}</h2>
    <ul>
      <li parentName="ul">{`As we already know, the JSX elements we write in our components`}<br parentName="li"></br>
        {`are converted to React.createElement by transpilers like Babel`}<br parentName="li"></br>
        {`and then the virtual DOM node is created by React.createElement.`}</li>
      <li parentName="ul">{`Hence while writing the code we do not have access to the actual`}<br parentName="li"></br>
        {`DOM node.`}</li>
      <li parentName="ul">{`In order to give us access to actual DOM node rendered by the JSX`}<br parentName="li"></br>
        {`React provides us with the 'ref' prop.`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const divRef = React.useRef()

return<div>
    <div ref={divRef}>I am a JSX DIV</div>
<div>
`}</code></pre>
    <ul>
      <li parentName="ul">{`Here we assign ref the "divRef", that will set the ".current" property`}<br parentName="li"></br>
        {`of the divRef as the div DOM node once the component has rendered`}</li>
      <li parentName="ul">{`And then we can manipulate the DOM node as per our requirement just`}<br parentName="li"></br>
        {`like we do with a DOM node in plain JavaScript`}</li>
      <li parentName="ul">{`We can also use "useRef" to store a value in it's current property.`}<br parentName="li"></br>
        {`The update of ".current" property does not cause a re-render. Also`}<br parentName="li"></br>
        {`the value remains persistent till the lifetime of the component.`}</li>
    </ul>
    <hr></hr>
    <h2>{`PureComponent`}</h2>
    <ul>
      <li parentName="ul">{`PureComponent in React has the same meaning as Pure functions`}<br parentName="li"></br>
        {`in JavaScript.`}</li>
      <li parentName="ul">{`A function that returns the same value for the same arguments`}<br parentName="li"></br>
        {`passed to it and that does not cause any side effect like manipulating`}<br parentName="li"></br>
        {`a variable outside the function is called a Pure function.`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const calculate1 = (a, b) => a * b
// This is a pure function

const PI = 3.14
const calculate2 = (a, b) => a * b * PI
// This is not a pure function because if the PI value  
// is changed then even with same values of a and b  
// the function will return different values
`}</code></pre>
    <hr></hr>
    <ul>
      <li parentName="ul">{`When a parent component in React is re-rendered due to some state`}<br parentName="li"></br>
        {`or prop update, all its children component are also re-rendered,`}<br parentName="li"></br>
        {`even though they don't require a re-render.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Parent>
    <Child1 />
    <Child2 />
</Parent>
// Here if Parent is re-rendered then Child1 and   
// Child2 will also be re-rendered
`}</code></pre>
    <hr></hr>
    <ul>
      <li parentName="ul">{`React is fast enough to not let such unnecessary re-renders cause`}<br parentName="li"></br>
        {`any slowness in appliaction but sometimes when we are dealing`}<br parentName="li"></br>
        {`with a render heavy child component that for some reason takes`}<br parentName="li"></br>
        {`time to render then we can prevent unnecessary renders for that`}<br parentName="li"></br>
        {`component by making them a PureComponent.`}</li>
      <li parentName="ul">{`The PureComponent implicitly implements shouldComponentUpdate()`}<br parentName="li"></br>
        {`lifecycle method and does a shallow comparison of props`}</li>
      <li parentName="ul">{`shouldComponentUpdate() is a lifecycle method that is invoked`}<br parentName="li"></br>
        {`before rendering when new props or state are being received.`}<br parentName="li"></br>
        {`Defaults to true.`}<br parentName="li"></br>
        {`We can compare the current props with previous props and return`}<br parentName="li"></br>
        {`false if they are same and we don't want the component to re-render`}</li>
      <li parentName="ul">{`Only class based component can become PureComponent`}</li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul">{`To make a class component Pure, the class needs to extend`}<br parentName="li"></br>
        {`React.PureComponent instead of React.Component`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`class ChildComponent extends React.PureComponent {
    .
    .
    .
}
`}</code></pre>
    <hr></hr>
    <h3>{`How can we make a Functional component behave like a PureComponent?`}</h3>
    <ul>
      <li parentName="ul">{`Using the React.memo() higher order component`}</li>
      <li parentName="ul">{`In JavaScript, a Higher order function is a function which takes`}<br parentName="li"></br>
        {`another function as an argument and/or returns a function`}</li>
      <li parentName="ul">{`Similarly in React a Higher order component takes another`}<br parentName="li"></br>
        {`component as an argument and returns a component`}</li>
      <li parentName="ul">{`React.memo() takes a non-memoized fucntional component`}<br parentName="li"></br>
        {`and returns a memoized functional component`}</li>
      <li parentName="ul">{`Since this also shallow compares the props, we can optionally add`}<br parentName="li"></br>
        {`a custom comparison function as the second argument`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`function MyComponent(props) {
  /* render using props */
}
function areEqual(prevProps, nextProps) {
  /*
  return true if passing nextProps to render would return
  the same result as passing prevProps to render,
  otherwise return false
  */
}
export default React.memo(MyComponent, areEqual);
`}</code></pre>
    <hr></hr>
    <h3>{`How does React compare props which are funtions and objects?`}</h3>
    <ul>
      <li parentName="ul">{`React compares the functions and objects props by reference`}</li>
      <li parentName="ul">{`Not just that, useEffect dependencies are also compared by`}<br parentName="li"></br>
        {`Object.is(), which compares objects and functions with references`}</li>
      <li parentName="ul">{`When a component is re-rendered, entire function of the`}<br parentName="li"></br>
        {`component is executed and at that time new reference of`}<br parentName="li"></br>
        {`object and function are created even though the actual`}<br parentName="li"></br>
        {`contents of the object and function is not changed`}</li>
      <li parentName="ul">{`Hence, even though you memoize your component with React.memo()`}<br parentName="li"></br>
        {`still the component will re-render if the props are either`}<br parentName="li"></br>
        {`objects or functions`}</li>
      <li parentName="ul">{`Similarly, your useEffect callback would be executed if the`}<br parentName="li"></br>
        {`dependencies are either objects or functions`}</li>
      <li parentName="ul">{`React provides two additional hook to solve this problem`}</li>
    </ul>
    <hr></hr>
    <h2>{`Memoizing functions with useCallback`}</h2>
    <ul>
      <li parentName="ul">{`useCallback takes two arguments`}
        <ul parentName="li">
          <li parentName="ul">{`the function to be memoized`}</li>
          <li parentName="ul">{`depedency array based on which it decides to`}<br parentName="li"></br>
            {`return the same or new reference`}</li>
        </ul>
      </li>
      <li parentName="ul">{`useCallback returns the memoized function, whose`}<br parentName="li"></br>
        {`reference will only change if any of dependencies has`}<br parentName="li"></br>
        {`changed`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const memoizedCallback = useCallback(
  (avenger) => console.log(\`Welcome \${avenger}\`),
  [avenger],
);
`}</code></pre>
    <hr></hr>
    <h2>{`Memoizing values(objects) with useMemo`}</h2>
    <ul>
      <li parentName="ul">{`useMemo takes two arguments`}
        <ul parentName="li">
          <li parentName="ul">{`a function which returns a value to be memoized`}</li>
          <li parentName="ul">{`depedency array based on which it decides to`}<br parentName="li"></br>
            {`return the same or new reference/value`}</li>
        </ul>
      </li>
      <li parentName="ul">{`useMemo returns the memoized value, whose`}<br parentName="li"></br>
        {`reference/value will only change if any of dependencies has`}<br parentName="li"></br>
        {`changed`}</li>
      <li parentName="ul">{`useMemo is also used to memoize computationally expensive`}<br parentName="li"></br>
        {`values`}</li>
    </ul>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// preserving object reference
const memoizedObj = useMemo(() => ({
    a:1,
    b:"Avenger",
}), [])

// memoizing computationally expensive values
const square = (a, b) => a ^ b 
const memoizedValue = useMemo(() => square(a, b), [a, b]);
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;